<template>
    <svg :width="36" :height="36" :viewBox="`0 0 36 36`" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_24_258)">
            <rect :width="36" :height="36" fill="transparent" />
            <g filter="url(#filter0_i_24_258)">
                <path
                    d="M24.4688 6.71489C22.7317 4.70879 20.7767 2.90234 18.6398 1.32896C18.4507 1.19645 18.2253 1.12537 17.9944 1.12537C17.7634 1.12537 17.5381 1.19645 17.3489 1.32896C15.216 2.903 13.2648 4.70942 11.5312 6.71489C7.66547 11.1544 5.625 15.8344 5.625 20.2501C5.625 23.5321 6.92879 26.6797 9.24955 29.0005C11.5703 31.3213 14.7179 32.6251 18 32.6251C21.2821 32.6251 24.4297 31.3213 26.7504 29.0005C29.0712 26.6797 30.375 23.5321 30.375 20.2501C30.375 15.8344 28.3345 11.1544 24.4688 6.71489ZM18 30.3751C15.3156 30.3721 12.742 29.3044 10.8438 27.4062C8.94567 25.5081 7.87798 22.9345 7.875 20.2501C7.875 12.2021 15.6755 5.48443 18 3.6563C20.3245 5.48443 28.125 12.1993 28.125 20.2501C28.122 22.9345 27.0543 25.5081 25.1562 27.4062C23.258 29.3044 20.6844 30.3721 18 30.3751ZM25.8595 21.5635C25.5678 23.1929 24.7839 24.6939 23.6132 25.8642C22.4426 27.0346 20.9415 27.8182 19.312 28.1096C19.2502 28.1195 19.1876 28.1247 19.125 28.1251C18.8428 28.125 18.5709 28.0189 18.3633 27.8277C18.1557 27.6366 18.0275 27.3744 18.0042 27.0932C17.9808 26.812 18.064 26.5322 18.2372 26.3095C18.4104 26.0867 18.6611 25.9372 18.9394 25.8905C21.2695 25.4982 23.2467 23.521 23.6419 21.1866C23.6919 20.8923 23.8567 20.63 24.1001 20.4572C24.3435 20.2845 24.6456 20.2155 24.9398 20.2655C25.2341 20.3155 25.4965 20.4803 25.6692 20.7237C25.8419 20.9672 25.9109 21.2692 25.8609 21.5635H25.8595Z"
                    fill="url(#paint0_linear_24_258)"
                />
            </g>
            <g opacity="0.3" filter="url(#filter1_f_24_258)">
                <path
                    d="M24.4688 6.71489C22.7317 4.70879 20.7767 2.90234 18.6398 1.32896C18.4507 1.19645 18.2253 1.12537 17.9944 1.12537C17.7634 1.12537 17.5381 1.19645 17.3489 1.32896C15.216 2.903 13.2648 4.70942 11.5312 6.71489C7.66547 11.1544 5.625 15.8344 5.625 20.2501C5.625 23.5321 6.92879 26.6797 9.24955 29.0005C11.5703 31.3213 14.7179 32.6251 18 32.6251C21.2821 32.6251 24.4297 31.3213 26.7504 29.0005C29.0712 26.6797 30.375 23.5321 30.375 20.2501C30.375 15.8344 28.3345 11.1544 24.4688 6.71489ZM18 30.3751C15.3156 30.3721 12.742 29.3044 10.8438 27.4062C8.94567 25.5081 7.87798 22.9345 7.875 20.2501C7.875 12.2021 15.6755 5.48443 18 3.6563C20.3245 5.48443 28.125 12.1993 28.125 20.2501C28.122 22.9345 27.0543 25.5081 25.1562 27.4062C23.258 29.3044 20.6844 30.3721 18 30.3751ZM25.8595 21.5635C25.5678 23.1929 24.7839 24.6939 23.6132 25.8642C22.4426 27.0346 20.9415 27.8182 19.312 28.1096C19.2502 28.1195 19.1876 28.1247 19.125 28.1251C18.8428 28.125 18.5709 28.0189 18.3633 27.8277C18.1557 27.6366 18.0275 27.3744 18.0042 27.0932C17.9808 26.812 18.064 26.5322 18.2372 26.3095C18.4104 26.0867 18.6611 25.9372 18.9394 25.8905C21.2695 25.4982 23.2467 23.521 23.6419 21.1866C23.6919 20.8923 23.8567 20.63 24.1001 20.4572C24.3435 20.2845 24.6456 20.2155 24.9398 20.2655C25.2341 20.3155 25.4965 20.4803 25.6692 20.7237C25.8419 20.9672 25.9109 21.2692 25.8609 21.5635H25.8595Z"
                    fill="url(#paint1_linear_24_258)"
                />
            </g>
            <path
                opacity="0.33"
                d="M6.75 19.125C6.75 11.925 14.25 4.875 18 2.25C21.75 4.5 29.25 11.025 29.25 19.125C29.25 29.25 19.6875 31.5 16.3125 30.9375C12.9375 30.375 6.75 28.125 6.75 19.125Z"
                fill="url(#paint2_linear_24_258)"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_24_258"
                x="5.625"
                y="1.12537"
                width="24.75"
                height="32.4997"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="0.75" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.951923 0 0 0 0 0.951923 0 0 0 0 0.951923 0 0 0 0.61 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_24_258" />
            </filter>
            <filter
                id="filter1_f_24_258"
                x="-0.6"
                y="-0.6"
                width="37.2"
                height="37.2"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="0.3" result="effect1_foregroundBlur_24_258" />
            </filter>
            <linearGradient
                id="paint0_linear_24_258"
                x1="13.6641"
                y1="1.12537"
                x2="22.3359"
                y2="32.6251"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#E0F0FF" />
                <stop offset="1" stop-color="#C0E0FD" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_24_258"
                x1="18"
                y1="1.12537"
                x2="18"
                y2="32.6251"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#C0E8FC" />
                <stop offset="1" stop-color="#90D0FA" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_24_258"
                x1="18.5625"
                y1="6.75"
                x2="27.5625"
                y2="28.125"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#D8F0FF" />
                <stop offset="0.774038" stop-color="#C0E8FC" />
                <stop offset="0.973173" stop-color="#90D0FA" />
            </linearGradient>
            <clipPath id="clip0_24_258">
                <rect width="36" height="36" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
<script>
export default {
    name: "HumiIcon",
};
</script>
